import { lineFor, unitIdentity, unitLabel } from '@d-orca/shared/client/logistics';
import type { Delivery } from '@interfaces/ILogistics';
import type { CardTranslate } from './boardCard.logic';

/**
 * A material's delivered total across its orders (Delivery History, per
 * material): summed per unit, counting only that material's line on each. A
 * material's orders share one unit in practice, but a history that mixes them
 * shows each sum ("2 kg + 5 pcs") rather than adding kg to pcs. Units group by
 * identity ('sheets' and '枚' are one unit) and show in the viewer's language;
 * amount-less lines are skipped, and a history with no amount at all shows no
 * total.
 */
export function historyTotal(orders: Delivery[], material: string, t: CardTranslate): string | null {
  const sums = new Map<string, { unit: string; sum: number }>();
  for (const order of orders) {
    // Every order in a material's history carries that material's line.
    const line = lineFor(order, material)!;
    if (line.quantity == null) continue;
    const unit = line.unit ?? '';
    const entry = sums.get(unitIdentity(unit));
    if (entry) entry.sum += line.quantity;
    else sums.set(unitIdentity(unit), { unit, sum: line.quantity });
  }
  if (sums.size === 0) return null;
  return [...sums.values()]
    .map(({ unit, sum }) => `${Math.round(sum * 100) / 100}${unit ? ` ${unitLabel(t, unit)}` : ''}`)
    .join(' + ');
}
